import mixpanel from 'mixpanel-browser';
import { environment } from '../config/environment';

interface UserProperties {
  email?: string;
  name?: string;
  clinic_id?: number;
  is_admin?: boolean;
  is_medical_officer?: boolean;
  is_super_admin?: boolean;
}

class AnalyticsService {
  private initialized = false;

  init(): void {
    const token = 'a4b6ba2b10ada7fcb1ec4fb2120f2b60';

    try {
      mixpanel.init(token, {
        autocapture: true,
        record_sessions_percent: 100,
        debug: environment.isDevelopment,
        track_pageview: true,
        persistence: 'localStorage',
      });

      this.initialized = true;
    } catch (error) {
      console.error('Failed to initialize Mixpanel:', error);
    }
  }

  identify(userId: string, properties?: UserProperties): void {
    if (!this.initialized) return;

    try {
      mixpanel.identify(userId);

      if (properties) {
        mixpanel.people.set({
          $email: properties.email,
          $name: properties.name,
          clinic_id: properties.clinic_id,
          is_admin: properties.is_admin,
          is_medical_officer: properties.is_medical_officer,
          is_super_admin: properties.is_super_admin,
        });
      }
    } catch (error) {
      console.error('Failed to identify user:', error);
    }
  }

  track(eventName: string, properties?: Record<string, unknown>): void {
    if (!this.initialized) return;

    try {
      mixpanel.track(eventName, properties);
    } catch (error) {
      console.error('Failed to track event:', error);
    }
  }

  trackPageView(pageName?: string): void {
    if (!this.initialized) return;

    try {
      mixpanel.track_pageview({ page: pageName });
    } catch (error) {
      console.error('Failed to track page view:', error);
    }
  }

  reset(): void {
    if (!this.initialized) return;

    try {
      mixpanel.reset();
    } catch (error) {
      console.error('Failed to reset analytics:', error);
    }
  }
}

export const analyticsService = new AnalyticsService();
